/**
 * Created by Owner on 2016/8/9.
 */
import {Component, OnInit} from '@angular/core';
import {NavController, AlertController, LoadingController, NavParams} from 'ionic-angular';
import {LotteryService} from "../../services/lottery.services";
import {BetDetailsBauCuaPage} from "../betDetailsBauCua/betDetailsBauCua";

@Component({
    templateUrl: 'baucuaHistory.html',
    selector: 'baucua-history-page',
})
export class BauCuaHistoryPage {
    private tamount: number = 0;
    private twin: number = 0;
    private totalNum: number = 0;
    private recordList: any = [];
    private is1Giay: boolean = false;
    private infiniteScrollBoolean: boolean = true;
    private gameID: number;


    constructor(private lotteryService: LotteryService, private alertCtrl: AlertController, private loadingCtrl: LoadingController, public params: NavParams, private nav: NavController) {
        const getDataParams = params['data'];
        this.gameID = Number(getDataParams['gameID']);
        this.gameID === 92 || this.gameID === 94 ? this.is1Giay = true : this.is1Giay = false;
        this.apiGetHistory();
    }

    apiGetHistory(refresher: any = null) {
        let dataParams = {lotteryid: this.gameID};
        this.lotteryService.lotteryRecordBean(dataParams, this).then(data => {
            if (!data["msg"]) {
                this.recordList = data["reslist"];
                if (this.is1Giay) {
                    this.recordList.map(item => {
                        item["issue"] = item["finishtime"].replace(/-/g,'/').substr(11);
                        return item;
                    });
                }
                this.recordList.map(item => {
                    item["bettime"] = item["bettime"].replace(/-/g,'/');
                    return item;
                });
                this.totalNum = data["totalrecord"];
                this.tamount = data["tamount"];
                this.twin = data["twin"];
                if (refresher) {
                    refresher.complete();
                    this.infiniteScrollBoolean = true;
                }
            }
        });
    }

    doInfinite(infiniteScroll) {
        infiniteScroll.enable(false);
        let dataParams = {lotteryid: this.gameID};
        this.lotteryService.lotteryNextRecordBean(dataParams, this).then(data => {
            if (!data["msg"]) {
                this.recordList = this.recordList.concat(data["reslist"]);
                if (this.is1Giay) {
                    this.recordList.map(item => {
                        item["issue"] = item["finishtime"].substr(11);
                        return item;
                    });
                }
                this.recordList.map(item => {
                    item["bettime"] = item["bettime"].replace(/-/g,'/');
                    return item;
                });
                this.totalNum = data["totalrecord"];
                infiniteScroll.complete();
                infiniteScroll.enable(true);
            } else {
                infiniteScroll.enable(true);
                this.infiniteScrollBoolean = false;
            }
        });
    }

    doRefresh(refresher) {
        this.apiGetHistory(refresher);
    }

    goDetail(betID: number) {
        this.nav.push(BetDetailsBauCuaPage, {
            betID: betID,
            gameID: this.gameID
        });
    }

    dismiss() {}

    ionViewWillEnter() {
        this.apiGetHistory();
    }
}



// WEBPACK FOOTER //
// ./src/pages/baucuaHistory/baucuaHistory.ts